import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { FaCalendarAlt, FaTag, FaInfoCircle, FaRupeeSign } from 'react-icons/fa'
import { GiConfirmed } from 'react-icons/gi'
import { useNavigate, useParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


export default function BookedDetailpage() {
  const { bookedId } = useParams() // Get the customerId from the URL
  const [customerName, setCustomerName] = useState('')
  const [customerTitle, setCustomerTitle] = useState('')
  const [brokerName, setBrokerName] = useState('')
  const [plotName, setPlotName] = useState('')
  const [booking, setBooking] = useState([])
  const [loading, setLoading] = useState(true)
  const token = Cookies.get('authToken')
  const navigate = useNavigate()
  

  // Create an Axios instance with default headers
  const axiosInstance = axios.create({
    baseURL: BASE_URL, // Set your API base URL
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`, // Set the Authorization header for all requests
    },
  })
  useEffect(() => {
    const fetchBookedBookings = async () => {
      setLoading(true)

      const token = Cookies.get('authToken') // Retrieve token from cookies

      try {
        // Fetch booking details using the bookedId
        const response = await axiosInstance.get(BASE_URL+
          `/get/booking?id=${bookedId}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        )

        const bookingData = response.data.data[0] // Assuming the response has booking data in `data.data`
        setBooking(bookingData) // Set booking data

        console.log('Response from booking: ', bookingData)

        // Fetch all customers
        const customerResponse = await axiosInstance.get(
          BASE_URL+'/customers',
        )
        setCustomerName(customerResponse.data.data) // Set customers list

        // Check if booking data exists and find the customer details
        if (bookingData && bookingData.customer_id) {
          // Find the customer by customer_id from booking
          const foundCustomer = customerResponse.data.data.find(
            (customer) => customer.id === bookingData.customer_id,
          )

          // If customer is found, set the customer name
          if (foundCustomer) {
            setCustomerName(foundCustomer.name)
            setCustomerTitle(foundCustomer.title)
          } else {
            toast.error('Customer not found')
          }
        }

        // Fetch all plot number
        const plotResponse = await axiosInstance.get(
          BASE_URL+'/plot/search',
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          },
        )
        setPlotName(plotResponse.data.data) // Set plots list

        // Check if booking data exists and find the plot details
        if (bookingData && bookingData.plot_id) {
          // Find the plot by plot_id from booking
          const foundPlot = plotResponse.data.data.find(
            (plot) => plot.id === bookingData.plot_id,
          )

          // If plot is found, set the plot name
          if (foundPlot) {
            setPlotName(foundPlot.plot_number)
          } else {
            toast.error('Plot not found')
          }
        }

        // Fetch all brokers with condition
        if (bookingData && bookingData.broker_id) {
          const brokerResponse = await axiosInstance.get(
            BASE_URL+'/brokers/search',
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            },
          )

          // Find the broker by broker_id from booking
          const foundBroker = brokerResponse.data.data.find(
            (broker) => broker.broker_id === bookingData.broker_id,
          )

          // If broker is found, set the broker name
          if (foundBroker) {
            setBrokerName(foundBroker.name) // Set broker's name
          } else {
            toast.error('Associate not found')
          }
        }
      } catch (error) {
        toast.error('Failed to fetch booking details')
      } finally {
        setLoading(false) // Set loading to false after fetching
      }
    }

    fetchBookedBookings()
  }, [bookedId]) // Dependency array

  const handlePrint = () => {
    navigate(`/BookingPrintpage/${bookedId}`)
  }

  if (loading) {
    return <p>Loading bookings ...</p>
  }
  if (!booking) {
    return <p>No booking data available.</p>
  }

  return (
    <div
      className="d-flex align-items-center justify-content-center vh-100"
      style={{ marginTop: '0px' }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={5} xl={6}>
            <Card
              className="shadow-lg border-0"
              style={{
                borderRadius: '20px',
                overflow: 'hidden',
                background: '#fff',
              }}
            >
              <Card.Body
                className="p-5"
                style={{
                  background: 'linear-gradient(135deg, #ffffff, #f9fafb)',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                }}
              >
                <h2 className="mb-2 text-center fw-bold" style={{color: theme.colors.secondary}}>
                  {customerTitle}
                  {'.'} {customerName}'s Booking
                </h2>

                {/* Booking Id */}
                <div
                  className="d-flex justify-content-between mb-3 mt-4"
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                >
                  <h6 className="fw-bold" style={{ color: '#333' }}>
                    <FaInfoCircle className="me-2" /> Booking Id
                  </h6>
                  <p className="text-end" style={{ color: '#777' }}>
                    {booking.id}
                  </p>
                </div>

                {/* Plot ID */}
                <div
                  className="d-flex justify-content-between mb-3"
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                >
                  <h6 className="fw-bold" style={{ color: '#333' }}>
                    <FaTag className="me-2" /> Plot Number
                  </h6>
                  <p className="text-end" style={{ color: '#777' }}>
                    {plotName}
                  </p>
                </div>

                {/* Broker ID */}
                <div
                  className="d-flex justify-content-between mb-3"
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                >
                  <h6 className="fw-bold" style={{ color: '#333' }}>
                    <FaInfoCircle className="me-2" /> Associate Name
                  </h6>
                  <p className="text-end" style={{ color: '#777' }}>
                    {brokerName || 'N/A'}
                  </p>
                </div>

                {/* Booking Date */}
                <div
                  className="d-flex justify-content-between mb-3"
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                >
                  <h6 className="fw-bold" style={{ color: '#333' }}>
                    <FaCalendarAlt className="me-2" /> Booking Date
                  </h6>
                  <p className="text-end" style={{ color: '#777' }}>
                    {booking.booking_date
                      ? new Date(booking.booking_date).toLocaleDateString(
                          'en-GB',
                          {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                          },
                        )
                      : 'N/A'}
                  </p>
                </div>

                {/* Due Date */}
                <div
                  className="d-flex justify-content-between mb-3"
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                >
                  <h6 className="fw-bold" style={{ color: '#333' }}>
                    <FaCalendarAlt className="me-2" /> Due Date
                  </h6>
                  <p className="text-end" style={{ color: '#777' }}>
                    {booking.due_date
                      ? new Date(booking.due_date).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric',
                        })
                      : 'N/A'}
                  </p>
                </div>

                {/* Actual Price */}
                <div
                  className="d-flex justify-content-between mb-3"
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                >
                  <h6 className="fw-bold" style={{ color: '#333' }}>
                    <FaRupeeSign className="me-2" /> Actual Amount
                  </h6>
                  <p className="text-end" style={{ color: '#777' }}>
                    {booking.actual_price
                      ? `₹ ${booking.actual_price.toLocaleString()}`
                      : 'N/A'}
                  </p>
                </div>

                {/* Discount Price */}
                <div
                  className="d-flex justify-content-between mb-3"
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                >
                  <h6 className="fw-bold" style={{ color: '#333' }}>
                    <FaRupeeSign className="me-2" /> Discount Amount
                  </h6>
                  <p className="text-end" style={{ color: '#777' }}>
                    {booking.discount_price !== null &&
                    booking.discount_price !== undefined
                      ? `₹ ${booking.discount_price.toLocaleString()}`
                      : 'N/A'}
                  </p>
                </div>

                {/* Final Price */}
                <div
                  className="d-flex justify-content-between mb-3"
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                >
                  <h6 className="fw-bold" style={{ color: '#333' }}>
                    <FaRupeeSign className="me-2" /> Final Amount
                  </h6>
                  <p className="text-end" style={{ color: '#777' }}>
                    ₹ {booking.final_price?.toLocaleString()}
                  </p>
                </div>

                {/* Booking Price */}
                <div
                  className="d-flex justify-content-between mb-3"
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                >
                  <h6 className="fw-bold" style={{ color: '#333' }}>
                    <FaRupeeSign className="me-2" /> Booking Amount
                  </h6>
                  <p className="text-end" style={{ color: '#777' }}>
                    ₹ {booking.booking_price?.toLocaleString()}
                  </p>
                </div>

                {/* Payment Status */}
                <div
                  className="d-flex justify-content-between mb-3"
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                >
                  <h6 className="fw-bold" style={{ color: '#333' }}>
                    <FaInfoCircle className="me-2" /> Payment Status
                  </h6>
                  <p className="text-end" style={{ color: '#777' }}>
                    {booking.booking_payment_status}
                  </p>
                </div>

                {/* Booking Status */}
                <div
                  className="d-flex justify-content-between mb-3"
                  style={{ borderBottom: '1px solid #e0e0e0' }}
                >
                  <h6 className="fw-bold" style={{ color: '#333' }}>
                    <GiConfirmed className="me-2" /> Booking Status
                  </h6>
                  <p className="text-end" style={{ color: '#777' }}>
                    {booking.booking_status}
                  </p>
                </div>
                <Col xs={12}>
                  <Button
                    variant="outline-secondary"
                    className="fw-bold no-print float-end"
                    onClick={handlePrint}
                  >
                    <i className="bi bi-file-earmark-pdf"></i> Print
                  </Button>
                </Col>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
